var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuanLyTruongHoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#fdbc42;}.cls-3{fill:#18b575;}.cls-4{fill:#3d55a5;}.cls-5{fill:#ed1869;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Qu\\u1EA3n_l\\xFD",
    "data-name": "Qu\\u1EA3n l\\xFD"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.42,97.45h53.37a5.14,5.14,0,0,1,5.14,5.14v50a0,0,0,0,1,0,0H160.42a5.14,5.14,0,0,1-5.14-5.14V102.6A5.14,5.14,0,0,1,160.42,97.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.27,88.92H77.8a9.29,9.29,0,0,0-9.28,9.28V184a9.29,9.29,0,0,0,9.28,9.28H209.65a9.28,9.28,0,0,0,9.28-9.28V152.58H162.35a7.07,7.07,0,0,1-7.08-7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.93,152.58H160.17a4.9,4.9,0,0,1-4.9-4.89V88.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.27,88.92l8.6,47.11a3.1,3.1,0,0,0,2.24,2.44l52.82,14.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-2",
    d: "M85.25,56.7A27.29,27.29,0,1,0,112.53,84,27.3,27.3,0,0,0,85.25,56.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.42,166.39c0,25.14-24.26,26.91-54.18,26.91s-54.17-1.77-54.17-26.91,24.25-45.54,54.17-45.54S139.42,141.23,139.42,166.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuanLyTruongHoc);
export default __webpack_public_path__ + "static/media/quan_ly_truong_hoc.b5cfc05d0e749f5e596084e74efba752.svg";
export { ForwardRef as ReactComponent };